<template>
  <v-col cols="12" md="8" class="mx-auto my-12 primary-form">
    <v-form v-if="!submitted" key="fraud-form" ref="form">
      <h2 class="h4">
        Your information (optional - you may remain anonymous):
      </h2>
      <personal-information-form v-model="model.yourInformation" />

      <h2 class="h4 mt-5">
        Insured's information (person who carries the insurance):
      </h2>
      <personal-information-form v-model="model.insuredsInformation" />

      <h2 class="h4 mt-5">Person or company your complaint is about:</h2>
      <personal-information-form v-model="model.personOrCompany" />

      <h2 class="h4 mt-5">Identifying Characteristics</h2>
      <div>
        <v-row dense>
          <v-col cols="6" md="4">
            <v-label for="race">Race</v-label>
            <base-input
              v-model="model.identifyingCharacteristics.race"
              name="race"
              color="primary"
            />
          </v-col>
          <v-col cols="6" md="4">
            <v-label for="weight">Weight</v-label>
            <base-input
              v-model="model.identifyingCharacteristics.weight"
              name="weight"
              color="primary"
            />
          </v-col>
          <v-col cols="6" md="4">
            <v-label for="height">Height</v-label>
            <base-input
              v-model="model.identifyingCharacteristics.height"
              name="height"
              color="primary"
            />
          </v-col>
          <v-col cols="12" class="base-radio">
            <v-radio-group
              name="sex"
              v-model="model.identifyingCharacteristics.sex"
            >
              <v-label>Sex</v-label>
              <v-radio label="male" value="male"></v-radio>
              <v-radio label="female" value="female"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="8">
            <v-label for="knownAssociates">Known associates</v-label>
            <base-input
              v-model="model.identifyingCharacteristics.knownAssociates"
              color="primary"
            ></base-input>
          </v-col>
          <v-col cols="6" md="4">
            <v-label for="dateOfIncident">Date of incedent(s)</v-label>
            <base-input
              name="dateOfIncident"
              v-model="model.identifyingCharacteristics.dateOfIncidents"
              color="primary"
              placeholder="mm/dd/yyyy"
            ></base-input>
          </v-col>
          <v-col cols="12">
            <v-label for="summaryOfComplaint">Summary of complaint</v-label>
            <v-textarea v-model="model.identifyingCharacteristics.summaryOfComplaint" outlined name="summaryOfComplaint"></v-textarea>
          </v-col>
        </v-row>
      </div>

      <vue-recaptcha
        style="margin-bottom: 25px;"
        class="d-flex justify-center"
        sitekey="6Lek_AsaAAAAAEDABb6z_1Wq9BuCcc74wSDhOKz-"
        :loadRecaptchaScript="true"
        @verify="verifyResponse"
        @expired="captchaExpired">
      </vue-recaptcha>

      <div class="d-flex justify-center">
        <base-button
          text="Submit"
          type="submit"
          @click="submit"
          :loading="loading"
          :disabled="recaptchaNotValidated"/>
      </div>
    </v-form>

    <p v-if="didError && siteConfig" class="error--text mt-4">
      Something went wrong! Look's like your request could not be
      completed. If this problem persists for you please reach out
      to us directly at {{ siteConfig.customerContactPhone | formatPhone }}
    </p>

    <confirmation-snippet
      v-if="submitted && !didError"
      key="confirm"
      :message="'thank you for your report'"
    />
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import ConfirmationSnippet from '../../snippets/confirmation-snippet'
import PersonalInformationForm from './form-snippets/personal-information-form'
import $http from '@/plugins/axios'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'FraudForm',
  components: {
    ConfirmationSnippet,
    PersonalInformationForm,
    VueRecaptcha
  },
  props: {
    fields: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      submitted: false,
      loading: false,
      didError: false,
      recaptchaNotValidated: true,
      recaptchaValidationToken: null,
      siteKey: process.env.VUE_APP_RECAPTCHA_PUBLIC,
      model: {
        recaptchaToken: '',
        emailTo: '', // Is set by siteconfig in created method
        yourInformation: {
          firstName: '',
          lastName: '',
          streetAddress: '',
          city: '',
          state: 'Select',
          zip: '',
          email: '',
          phone: '',
          eveningPhone: ''
        },
        insuredsInformation: {
          firstName: '',
          lastName: '',
          enrolleeId: '',
          streetAddress: '',
          city: '',
          state: 'Select',
          zip: '',
          phone: ''
        },
        personOrCompany: {
          name: '',
          streetAddress: '',
          city: '',
          state: 'Select',
          zip: '',
          phone: ''
        },
        identifyingCharacteristics: {
          race: '',
          sex: '',
          weight: '',
          height: '',
          knownAssociates: '',
          dateOfIncidents: '',
          summaryOfComplaint: ''
        }
      }
    }
  },
  computed: {
    ...mapState({ siteConfig: (state) => state.site.siteConfig })
  },
  created () {
    this.model.emailTo = this.siteConfig.reportFraudEmail
  },
  methods: {
    submit () {
      if (this.loading) {
        return false
      }
      this.didError = false
      this.loading = true
      if (this.validate(this.$refs.form)) {
        $http()
          .post('FraudFunction', this.model, { handleError: false })
          .then(() => {
            this.submitted = true
          })
          .catch(() => {
            this.didError = true
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    validate (form) {
      const errs = form.inputs.filter(function (input) {
        return !input.validate(true)
      })
      if (errs.length) {
        errs[0].focus()
        return false
      } else {
        return true
      }
    },
    verifyResponse (success) {
      this.recaptchaValidationToken = success
      this.model.recaptchaToken = this.recaptchaValidationToken
      this.recaptchaNotValidated = false
    },
    captchaExpired () {
      this.recaptchaValidationToken = ''
      this.model.recaptchaToken = ''
      this.recaptchaNotValidated = true
    }
  }
}
</script>
